import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import useTranslation from "@babackapp/translations/use-translation";
import { useAnalyticsFilters } from "../../hooks/use-analytics-filters";
import { GroupBy } from "../../providers/analytics-filters.provider";

export function GroupByToggle() {
  const t = useTranslation();
  const { groupBy, setGroupBy } = useAnalyticsFilters();

  return (
    <ToggleGroup
      type="single"
      value={groupBy}
      onValueChange={(value) => {
        if (value) setGroupBy(value as GroupBy);
      }}
      className="border rounded-md"
    >
      <ToggleGroupItem value="productId" size="sm" className="text-xs px-3">
        {t("analytics.groupByProduct")}
      </ToggleGroupItem>
      <ToggleGroupItem value="sku" size="sm" className="text-xs px-3">
        {t("analytics.groupBySku")}
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
